import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const EventProfile = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-3 compact-form">
        <h3 className="mb-3 text-white" style={{ fontSize: "1.5rem" }}>Event Profile</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label>Event Name</Form.Label>
              <Form.Control
                type="text"
                name="eventName"
                value={formData.eventName}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="eventType">
              <Form.Label>Event Type</Form.Label>
              <Form.Select
                name="eventType"
                value={formData.eventType}
                onChange={handleFormChange}
                className="dark-input"
              >
                <option value="">Select Event Type</option>
                <option value="conference">Conference</option>
                <option value="concert">Concert</option>
                <option value="wedding">Wedding</option>
                <option value="corporate">Corporate</option>
                <option value="festival">Festival</option>
                <option value="other">Other</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-2" controlId="eventDescription">
          <Form.Label>Event Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="eventDescription"
            value={formData.eventDescription}
            onChange={handleFormChange}
            className="dark-input"
          />
        </Form.Group>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="primaryContactName">
              <Form.Label>Primary Contact Name</Form.Label>
              <Form.Control
                type="text"
                name="primaryContactName"
                value={formData.primaryContactName}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="primaryContactEmail">
              <Form.Label>Primary Contact Email</Form.Label>
              <Form.Control
                type="email"
                name="primaryContactEmail"
                value={formData.primaryContactEmail}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="primaryContactPhone">
              <Form.Label>Primary Contact Phone</Form.Label>
              <Form.Control
                type="tel"
                name="primaryContactPhone"
                value={formData.primaryContactPhone}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EventProfile;